import goals from "../../../../src/components/content/goals/m3";
import * as React from 'react';
export default {
  goals,
  React
};